/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useState } from "react";
import { message, Select } from "antd";
import { msgClose } from "../../../utils";
import MapPropsContext from "../MapPropsContext";
import { StyledButton, StyledDisabledButton } from "../../../styled-components/Button";
import { JSON_SIGUNGU, TI_SELECT_SIGUNGOO_INPUT, TI_SELECT_SIGUNGOO_RESET_BUTTON } from "../../../Constants";

let isDistrictSearch = false;

export default function WidgetDistrictSelect({
  isShowDistrictLayerFromGeoserver,
  hidden,
  onlyLv1,
  injectDistrictLv1Value,
  injectDistrictLv2Value,
  areUcellularCommon = false,
  noAllLv1,
  nationwideZoomAdj = 0,
}) {
  const {
    setMapBounds,
    currentDistrictCode,
    setCurrentDistrictCode,
    setManualDistrictLayerParamsByGeoserver,
    currentDistrictName,
    viewState,
    onChangeWidgetState,
    setPointsResponseList,
  } = useContext(MapPropsContext);

  message.config({
    top: 250,
    duration: 5,
    maxCount: 1,
  });

  const infoByDistirctCode = () => {
    message.info(
      {
        content: <span style={{ fontSize: 15 }}> 시군구를 선택해 주시기 바랍니다.</span>,
      },
      msgClose
    );
  };

  useEffect(() => {
    if (isShowDistrictLayerFromGeoserver) {
      setManualDistrictLayerParamsByGeoserver({
        typeName: "KCA:TL_SCCO_SID_SIMPLE",
      });
    }

    if (noAllLv1) {
      DISTRICT_LV1_OPTIONS = DISTRICT_LV1_OPTIONS.filter((item) => item.value !== "");
    }
  }, []);

  useEffect(() => {
    if (isShowDistrictLayerFromGeoserver) {
      let tmpCurrentDistrictCode = currentDistrictCode;
      if (injectDistrictLv1Value !== undefined) {
        tmpCurrentDistrictCode = injectDistrictLv1Value;
      }
      if (!tmpCurrentDistrictCode) {
        setManualDistrictLayerParamsByGeoserver({
          typeName: "KCA:TL_SCCO_SID_SIMPLE",
        });
      } else {
        setManualDistrictLayerParamsByGeoserver({
          typeName: "KCA:TL_SCCO_SIG_SIMPLE",
          CQL_FILTER: `SIG_CD LIKE '${tmpCurrentDistrictCode}%'`,
        });

        if (tmpCurrentDistrictCode.length === 2) {
          onChangeDistrictLv1(tmpCurrentDistrictCode);
          const { mbrlx, mbrly, mbrrx, mbrry } = DISTRICT_LV1_DICT[tmpCurrentDistrictCode];
          setMapBounds([
            [mbrly, mbrlx],
            [mbrry, mbrrx],
          ]);
        } else {
          setDistrictLv2Value(tmpCurrentDistrictCode);
        }
      }
    }
  }, [currentDistrictCode, isShowDistrictLayerFromGeoserver, setManualDistrictLayerParamsByGeoserver]);

  const [districtLv1Value, setDistrictLv1Value] = useState();
  const [districtLv2Value, setDistrictLv2Value] = useState();
  const [districtLv2List, setDistrictLv2List] = useState([]);

  const { zoom } = viewState;

  // 시도 단위일 때, geojson 요청하지 못하도록 설정하기
  // const {imCellularCommon} = widgetState;
  useEffect(() => {
    if (currentDistrictCode && currentDistrictCode.length === 2 && areUcellularCommon) {
      onChangeWidgetState({
        target: { name: "imCellularCommonSido", value: true },
      });
    }
  }, [currentDistrictCode, areUcellularCommon]);

  useEffect(() => {
    if (injectDistrictLv1Value && !areUcellularCommon) {
      onChangeDistrictLv1(injectDistrictLv1Value);
    }
  }, [injectDistrictLv1Value, areUcellularCommon]);

  // zoom레벨 8이하부터 전국 단위로 셋팅하기
  useEffect(() => {
    if (zoom < 9 - nationwideZoomAdj) {
      setCurrentDistrictCode(undefined);
      setDistrictLv2Value(undefined);
      setDistrictLv1Value(undefined);
      setDistrictLv2List([]);
    }
  }, [zoom]);

  useEffect(() => {
    if (injectDistrictLv2Value && injectDistrictLv2Value.length === 5) {
      const districtLv1Code = injectDistrictLv2Value.substr(0, 2);
      onChangeDistrictLv1(districtLv1Code, true, injectDistrictLv2Value);
      setDistrictLv2Value(injectDistrictLv2Value);
      if (message) message.destroy();
    }
  }, [injectDistrictLv2Value]);

  useEffect(() => {
    if (currentDistrictName && currentDistrictName.length >= 2) {
      const shortName = currentDistrictName.substr(0, 2);
      const row = DISTRICT_LV1_OPTIONS.find((element) => element.shortName === shortName).value;
      isDistrictSearch = true;
      onChangeDistrictLv1(row);
    }
  }, [currentDistrictName]);

  useEffect(() => {
    let lv2Value = districtLv2Value;

    // lv2Value 값이 없고, districtLv2List에 항목이 있을 때, list의 첫번째 코드를 적용
    if (!lv2Value && districtLv2List.length > 0) {
      const [{ SIG_CD }] = districtLv2List;
      lv2Value = SIG_CD;
    }

    if (setCurrentDistrictCode) {
      setCurrentDistrictCode(lv2Value);
    }

    const selectedDistrictLv2 = districtLv2List.find(({ SIG_CD }) => SIG_CD === lv2Value);
    if (selectedDistrictLv2 && !isDistrictSearch) {
      const { LX, LY, RX, RY } = selectedDistrictLv2;
      setMapBounds([
        [LY, LX],
        [RY, RX],
      ]);
    }
  }, [setCurrentDistrictCode, districtLv2Value, districtLv2List]);

  const onChangeDistrictLv1 = useCallback(
    (districtLv1Code, onlyUpdateDistrictLv2List = false, presetDistrictLv2Code = null) => {
      setDistrictLv1Value(districtLv1Code);

      if (districtLv1Code.length === 0) {
        // 전국 지도 일 때
        setMapBounds([
          [38.71980474264239, 124.63439941406251],
          [34.88593094075317, 129.73205566406253],
        ]);
        setDistrictLv2List([]);
        if (setCurrentDistrictCode) setCurrentDistrictCode(districtLv1Code);

        setDistrictLv2Value(undefined);
      } else {
        // 그 외의 지역인 경우
        const data = JSON_SIGUNGU.filter(({ SID_CD }) => SID_CD === districtLv1Code);
        const allData = DISTRICT_LV1_OPTIONS.filter(({ value }) => value === districtLv1Code).map(
          ({ value, label, lon, lat, mbrrx, mbrry, mbrlx, mbrly }) => {
            return {
              RX: mbrrx,
              RY: mbrry,
              SIG_CD: districtLv1Code,
              SIG_KOR_NM: "전체",
              LON: lon,
              LAT: lat,
              LX: mbrlx,
              LY: mbrly,
            };
          }
        );
        const sigugunListWithAll = allData.concat(data);

        setDistrictLv2List(sigugunListWithAll);

        if (!onlyUpdateDistrictLv2List) {
          const { mbrlx, mbrly, mbrrx, mbrry } = DISTRICT_LV1_DICT[districtLv1Code];
          if (!isDistrictSearch) {
            setMapBounds([
              [mbrly, mbrlx],
              [mbrry, mbrrx],
            ]);
          }

          if (setCurrentDistrictCode) {
            setCurrentDistrictCode(districtLv1Code);
            isDistrictSearch = false;
          }

          if (presetDistrictLv2Code) setDistrictLv2Value(presetDistrictLv2Code);
          else setDistrictLv2Value(undefined);
          /*
      const url = getApiHost() + '/address/getSigugun.json';
      const params = {ctprvn_cd: districtLv1Code};
      Axios.get(url, {params})
        .then(({data}) => {
          // 전체 검색 추가

          }
        })
        .catch(reason => console.error(reason));
         */
        }
      }
    },
    []
  );

  const onChangeDistrictLv2 = useCallback(
    (districtLv2Code) => {
      setDistrictLv2Value(districtLv2Code);
    },
    [districtLv2List]
  );

  // 시군구는 미선택하고 시도만 선택한 경우 알림메세지 띄우기
  useEffect(() => {
    if (areUcellularCommon) {
      // 공용화가능 무선국 찾기 페이지인 경우
      setPointsResponseList([]);
      if (districtLv1Value && !districtLv2Value) {
        infoByDistirctCode();
      }
      if (districtLv1Value && districtLv2Value) msgClose();
    }
  }, [districtLv1Value, districtLv2Value, areUcellularCommon]);

  const onReset = () => {
    onChangeDistrictLv2(undefined);
  };

  return (
    <div hidden={hidden}>
      {/* ////1005_시군구 클릭 임시막기
      <Select value={districtLv1Value}
              onChange={value => onChangeDistrictLv1(value)}
              placeholder={"시도를 선택해주세요."}
              style={{width: '100%', marginBottom: 6}}>
        {DISTRICT_LV1_OPTIONS.map(({value, label}) =>
          <Select.Option value={value} key={value}>
            {label}
          </Select.Option>
        )}
      </Select>
      */}
      {districtLv2List.length > 0 && !onlyLv1 && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Select
            value={districtLv2Value}
            onChange={onChangeDistrictLv2}
            placeholder={"시군구를 선택해주세요."}
            style={{ width: "74%" }}
            tabIndex={TI_SELECT_SIGUNGOO_INPUT}
          >
            {districtLv2List.map(({ SIG_CD, SIG_KOR_NM }) => (
              <Select.Option value={SIG_CD} key={SIG_CD}>
                {SIG_KOR_NM}
              </Select.Option>
            ))}
          </Select>
          {districtLv2Value ? (
            <StyledButton
              onClick={onReset}
              style={{ marginLeft: "2px" }}
              disabled={!districtLv2Value}
              tabIndex={TI_SELECT_SIGUNGOO_RESET_BUTTON}
            >
              초기화
            </StyledButton>
          ) : (
            <StyledDisabledButton style={{ marginLeft: "2px" }} tabIndex={TI_SELECT_SIGUNGOO_RESET_BUTTON}>
              초기화
            </StyledDisabledButton>
          )}
        </div>
      )}
    </div>
  );
}

export let DISTRICT_LV1_OPTIONS = [
  { value: "", label: "전체" },
  {
    value: "11",
    label: "서울특별시",
    shortName: "서울",
    lon: "126.991806921484",
    lat: "37.5519031317135",
    mbrlx: "126.764483959747",
    mbrly: "37.4282974780154",
    mbrrx: "127.183794925579",
    mbrry: "37.7014552804408",
  },
  {
    value: "26",
    label: "부산광역시",
    shortName: "부산",
    lon: "129.060479518248",
    lat: "35.2019282064847",
    mbrlx: "128.761717879948",
    mbrly: "34.8896761403332",
    mbrrx: "129.305604759556",
    mbrry: "35.3890374481047",
  },
  {
    value: "27",
    label: "대구광역시",
    shortName: "대구",
    lon: "128.565235124895",
    lat: "35.8297466383903",
    mbrlx: "128.351475714273",
    mbrly: "35.6065398989539",
    mbrrx: "128.762692673716",
    mbrry: "36.0161651180033",
  },
  {
    value: "28",
    label: "인천광역시",
    shortName: "인천",
    lon: "126.376633455109",
    lat: "37.5850996582702",
    mbrlx: "124.609708786479",
    mbrly: "36.9199481978536",
    mbrrx: "126.793695445176",
    mbrry: "37.9842101997867",
  },
  {
    value: "29",
    label: "광주광역시",
    shortName: "광주",
    lon: "126.835437412188",
    lat: "35.1557371894239",
    mbrlx: "126.644702847086",
    mbrly: "35.0508954274288",
    mbrrx: "127.022275223762",
    mbrry: "35.2587039768941",
  },
  {
    value: "30",
    label: "대전광역시",
    shortName: "대전",
    lon: "127.394021670269",
    lat: "36.3398049356709",
    mbrlx: "127.246652706849",
    mbrly: "36.1831000582346",
    mbrrx: "127.55967871487",
    mbrry: "36.500230641149",
  },
  {
    value: "31",
    label: "울산광역시",
    shortName: "울산",
    lon: "129.237621886173",
    lat: "35.5541864958019",
    mbrlx: "128.971190344483",
    mbrly: "35.3293263010934",
    mbrrx: "129.463857345022",
    mbrry: "35.7249197899983",
  },
  {
    value: "36",
    label: "세종특별자치도",
    shortName: "세종",
    lon: "127.258780178998",
    lat: "36.5606573846651",
    mbrlx: "127.127729913637",
    mbrly: "36.4067584014689",
    mbrrx: "127.410803579214",
    mbrry: "36.7338218782086",
  },
  {
    value: "41",
    label: "경기도",
    shortName: "경기",
    lon: "127.181244300511",
    lat: "37.5331679158167",
    mbrlx: "126.38010162264",
    mbrly: "36.8937750173004",
    mbrrx: "127.848113144961",
    mbrry: "38.2822605492862",
  },
  {
    value: "42",
    label: "강원도",
    shortName: "강원",
    lon: "128.303271557156",
    lat: "37.7183639437493",
    mbrlx: "127.09503764164",
    mbrly: "37.0278324907037",
    mbrrx: "129.363781277665",
    mbrry: "38.6137093105104",
  },
  {
    value: "43",
    label: "충청북도",
    shortName: "충북",
    lon: "127.830433354713",
    lat: "36.7378781219474",
    mbrlx: "127.275650456932",
    mbrly: "36.0122068357305",
    mbrrx: "128.652096499356",
    mbrry: "37.2583342823382",
  },
  {
    value: "44",
    label: "충청남도",
    shortName: "충남",
    lon: "126.851244882346",
    lat: "36.529004361997",
    mbrlx: "125.540787998748",
    mbrly: "35.9782641246846",
    mbrrx: "127.639748255377",
    mbrry: "37.0647537432463",
  },
  {
    value: "45",
    label: "전라북도",
    shortName: "전북",
    lon: "127.142462782762",
    lat: "35.7157462543093",
    mbrlx: "125.966846555899",
    mbrly: "35.2992325988233",
    mbrrx: "127.911367380773",
    mbrry: "36.1565704346873",
  },
  {
    value: "46",
    label: "전라남도",
    shortName: "전남",
    lon: "126.904571633551",
    lat: "34.8779948855609",
    mbrlx: "125.077726359004",
    mbrly: "33.9685728568875",
    mbrrx: "127.905626550191",
    mbrry: "35.4869138264317",
  },
  {
    value: "47",
    label: "경상북도",
    shortName: "경북",
    lon: "128.916954",
    lat: "36.342314",
    mbrlx: "127.796152131964",
    mbrly: "35.5668881623958",
    mbrrx: "129.390616",
    mbrry: "37.070477",
  },
  {
    value: "48",
    label: "경상남도",
    shortName: "경남",
    lon: "128.261407773343",
    lat: "35.3243206532319",
    mbrlx: "127.57607074399",
    mbrly: "34.502007702385",
    mbrrx: "129.219071995387",
    mbrry: "35.9099440601097",
  },
  {
    value: "50",
    label: "제주특별자치도",
    shortName: "제주",
    lon: "126.553683449534",
    lat: "33.3870625865317",
    mbrlx: "126.144115835938",
    mbrly: "33.1137120720598",
    mbrrx: "126.970427989198",
    mbrry: "34.0153032275122",
  },
];

const DISTRICT_LV1_DICT = {
  11: {
    lon: "126.991806921484",
    lat: "37.5519031317135",
    mbrlx: "126.764483959747",
    mbrly: "37.4282974780154",
    mbrrx: "127.183794925579",
    mbrry: "37.7014552804408",
  },
  26: {
    lon: "129.060479518248",
    lat: "35.2019282064847",
    mbrlx: "128.761717879948",
    mbrly: "34.8896761403332",
    mbrrx: "129.305604759556",
    mbrry: "35.3890374481047",
  },
  27: {
    lon: "128.565235124895",
    lat: "35.8297466383903",
    mbrlx: "128.351475714273",
    mbrly: "35.6065398989539",
    mbrrx: "128.762692673716",
    mbrry: "36.0161651180033",
  },
  28: {
    lon: "126.376633455109",
    lat: "37.5850996582702",
    mbrlx: "124.609708786479",
    mbrly: "36.9199481978536",
    mbrrx: "126.793695445176",
    mbrry: "37.9842101997867",
  },
  29: {
    lon: "126.835437412188",
    lat: "35.1557371894239",
    mbrlx: "126.644702847086",
    mbrly: "35.0508954274288",
    mbrrx: "127.022275223762",
    mbrry: "35.2587039768941",
  },
  30: {
    lon: "127.394021670269",
    lat: "36.3398049356709",
    mbrlx: "127.246652706849",
    mbrly: "36.1831000582346",
    mbrrx: "127.55967871487",
    mbrry: "36.500230641149",
  },
  31: {
    lon: "129.237621886173",
    lat: "35.5541864958019",
    mbrlx: "128.971190344483",
    mbrly: "35.3293263010934",
    mbrrx: "129.463857345022",
    mbrry: "35.7249197899983",
  },
  36: {
    lon: "127.258780178998",
    lat: "36.5606573846651",
    mbrlx: "127.127729913637",
    mbrly: "36.4067584014689",
    mbrrx: "127.410803579214",
    mbrry: "36.7338218782086",
  },
  41: {
    lon: "127.181244300511",
    lat: "37.5331679158167",
    mbrlx: "126.38010162264",
    mbrly: "36.8937750173004",
    mbrrx: "127.848113144961",
    mbrry: "38.2822605492862",
  },
  42: {
    lon: "128.303271557156",
    lat: "37.7183639437493",
    mbrlx: "127.09503764164",
    mbrly: "37.0278324907037",
    mbrrx: "129.363781277665",
    mbrry: "38.6137093105104",
  },
  43: {
    lon: "127.830433354713",
    lat: "36.7378781219474",
    mbrlx: "127.275650456932",
    mbrly: "36.0122068357305",
    mbrrx: "128.652096499356",
    mbrry: "37.2583342823382",
  },
  44: {
    lon: "126.851244882346",
    lat: "36.529004361997",
    mbrlx: "125.540787998748",
    mbrly: "35.9782641246846",
    mbrrx: "127.639748255377",
    mbrry: "37.0647537432463",
  },
  45: {
    lon: "127.142462782762",
    lat: "35.7157462543093",
    mbrlx: "125.966846555899",
    mbrly: "35.2992325988233",
    mbrrx: "127.911367380773",
    mbrry: "36.1565704346873",
  },
  46: {
    lon: "126.904571633551",
    lat: "34.8779948855609",
    mbrlx: "125.077726359004",
    mbrly: "33.9685728568875",
    mbrrx: "127.905626550191",
    mbrry: "35.4869138264317",
  },
  47: {
    lon: "128.916954",
    lat: "36.342314",
    mbrlx: "127.796152131964",
    mbrly: "35.5668881623958",
    mbrrx: "129.390616",
    mbrry: "37.070477",
  },
  48: {
    lon: "128.261407773343",
    lat: "35.3243206532319",
    mbrlx: "127.57607074399",
    mbrly: "34.502007702385",
    mbrrx: "129.219071995387",
    mbrry: "35.9099440601097",
  },
  50: {
    lon: "126.553683449534",
    lat: "33.3870625865317",
    mbrlx: "126.144115835938",
    mbrly: "33.1137120720598",
    mbrrx: "126.970427989198",
    mbrry: "34.0153032275122",
  },
};
